import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * this service will hold the translations
 * which can be accessed any where to get text from translations
 */
@Injectable({
  providedIn: 'root',
})
export class AppTranslationsService {
  translations: any = {};
  constructor(private translate: TranslateService) {
    // Subscribe to the translation stream to get translations
    this.translate.stream('en-US').subscribe(
      (translations: any) => {
        console.log('[AppTranslationsService] Translations loaded:', Object.keys(translations || {}).length, 'keys');
        this.translations = translations || {};
      },
      (error: any) => {
        console.error('[AppTranslationsService] Failed to load translations:', error);
        this.translations = {};
      }
    );
  }
}
